import React from 'react'

export default props => (
  <h1 className={`norms-24 norms-48-l fw5 ma0 tc white ${props.className}`}>
    {props.children}
  </h1>
)
